module.exports = __webpack_public_path__ + "static/img/服务号.11ec779e.jpg";